import { render, staticRenderFns } from "./RegisterBtn.vue?vue&type=template&id=9639fc9c&"
import script from "./RegisterBtn.vue?vue&type=script&lang=js&"
export * from "./RegisterBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports